
import { useState, useCallback } from 'react';
import {
  DashboardState,
  FilterOption,
  SortOption,
  ViewMode,
} from '../types/dashboard.types';

const INITIAL_STATE: DashboardState = {
  searchQuery: '',
  filterStatus: 'all',
  sortBy: 'lastUpdated',
  viewMode: 'grid',
};

export const useDashboardQueryState = () => {
  const [state, setState] = useState<DashboardState>(INITIAL_STATE);

  const updateSearch = useCallback((query: string) => {
    setState((prev) => ({ ...prev, searchQuery: query }));
  }, []);

  const updateFilter = useCallback((filter: FilterOption) => {
    setState((prev) => ({ ...prev, filterStatus: filter }));
  }, []);

  const updateSort = useCallback((sort: SortOption) => {
    setState((prev) => ({ ...prev, sortBy: sort }));
  }, []);

  const updateViewMode = useCallback((mode: ViewMode) => {
    setState((prev) => ({ ...prev, viewMode: mode }));
  }, []);

  const reset = useCallback(() => {
    setState(INITIAL_STATE);
  }, []);

  return {
    state,
    updateSearch,
    updateFilter,
    updateSort,
    updateViewMode,
    reset,
  };
};
